

<label class="grilla">
  <input
    type="radio"
    [name]="name"
    [class]="getSmileyClass()"
    [ngClass]="getErrorClass()"
    [value]="value"
    (click)="onClick()"
  />
  <!-- <span class="description">{{ description }}</span> -->
</label>
